var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-test":"forget-shop__page"}},[_vm._v("Déconnexion magasin...")])}
var staticRenderFns = []

export { render, staticRenderFns }